<p-sidebar
  [(visible)]="pdfService.displayViewer"
  [fullScreen]="true"
  (onHide)="onHide()"
  [baseZIndex]="2000"
>
  <div>
    <button
      class="btn btn-danger btn-sm"
      pTooltip="Descargar pdf"
      appendTo="body"
      tooltipZIndex="999999999"
      (click)="downloadFile('pdf')"
    >
      <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
    </button>
    <button
      class="btn btn-success btn-sm"
      pTooltip="Descargar excel"
      appendTo="body"
      tooltipZIndex="999999999"
      (click)="pdfService.requestBlobXlsx()"
      [disabled]="pdfService.disableXlsx"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i>
    </button>
  </div>
  <div style="height: 88vh" class="pt-1">
    <ng2-pdfjs-viewer
      viewerId="7e98f7cb-a63c-44f9-b81c-4501ff484060"
      locale="es-MX"
      [downloadFileName]="params.fileName"
      [openFile]="false"
      [download]="false"
      zoom="page-width"
      [diagnosticLogs]="!env.production"
      (onDocumentLoad)="onDocumentLoad()"
      [viewBookmark]="false"
    ></ng2-pdfjs-viewer>
  </div>
</p-sidebar>
